import React, { Fragment } from 'react';

import Chart from 'react-apexcharts';

import { generateKey } from 'Helpers/misc';

export default function EvaluationTemplateSummaryWinner(props) {
    const colors = ['#E7DCFC', '#A2DDFC'];
    const getChartOptions = (weighting, color) => {
        return {
            chart: {
                fontFamily: 'var(--font-sans)',
                type: 'pie',
                width: '100%',
                height: 200,
            },
            dataLabels: {
                enabled: false,
            },
            plotOptions: {
                pie: {
                    customScale: 0.7,
                    donut: {
                        size: '60%',
                        labels: {
                            show: false,
                            value: {
                                show: false,
                            },
                        },
                    },
                    offsetY: 0,
                },
                stroke: {
                    colors: undefined,
                },
            },
            title: {
                text: props.name,
                style: {
                    fontSize: '18px',
                    color: '#000061',
                },
            },
            legend: {
                show: false,
                floating: false,
                showForNullSeries: true,
                showForZeroSeries: true,
                position: 'bottom',
                height: 80,
            },
            series: [weighting, 100 - weighting],
            colors: [color, '#21005C'],
        };
    };

    const getCompanyName = (id) => {
        const company = props.companies.find((item) => {
            return parseInt(item.id) === parseInt(id);
        });

        return company ? company.name : '';
    };

    return (
        <>
            <div className="row pt-2">
                <div className="col-sm-6 col-md-6 col-lg-4">
                    <div className="card bg-white border-0 rounded-15px py-2 shadow">
                        <div>
                            <div className="card-body">
                                <h4 className="font-weight-bold">{$t('Summary Scores')}</h4>
                                <div className="row">
                                    {props.data.map((row, index) => {
                                        return (
                                            <div className={'col-sm col-md-6'} key={generateKey()}>
                                                <div
                                                    style={{
                                                        position: 'relative',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                        }}
                                                    >
                                                        {row.weighting}%
                                                    </div>
                                                    <Chart
                                                        options={getChartOptions(row.weighting, colors[index % 2])}
                                                        series={getChartOptions(row.weighting, colors[index % 2]).series}
                                                        type={'donut'}
                                                        height={200}
                                                    />
                                                </div>
                                                <div className="text-center">{getCompanyName(row.id)}</div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row pt-2">
                <div className="col-sm-6 col-md-6 col-lg-4">
                    <div className="card bg-white border-0 rounded-15px py-2 shadow">
                        <div className="float-right px-2">
                            <div className="card-body">
                                <p>{$t('Winner')}:</p>
                                <h3 className="font-weight-bold">{getCompanyName(props.data[0].id)}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
